import { Component } from "react";
import React from "react";
import CardList from "../components/CardList";
import SearchBox from '../components/SearchBox';
import Scroll from '../components/Scroll'
import './App.css'
// import { robots } from './robots';

class App extends Component {
    constructor() {
        super()
        this.state = {
        users: [],
        searchfield: '',
        }
    }

    componentDidMount() {
        fetch('https://jsonplaceholder.typicode.com/users')
        .then(response=> response.json())
        .then(users => this.setState({users:users}));
    }

    onSearchChange = (event) => {
        this.setState({searchfield: event.target.value})
    }

    render() {
        const {users, searchfield} = this.state
        const filteredRobots = users.filter(robot => {
            return robot.name.toLowerCase().includes(searchfield.toLowerCase())
        })
            return !users.length ? 
            <h1 className="f1 ttu"> Loading ... </h1> :

            (
            <div className="tc" >
                <h1 className="f1">KittyFinder</h1>
                <SearchBox searchChange={this.onSearchChange} />
                <Scroll>
                    <CardList robots={filteredRobots} />
                </Scroll>
            </div>
        
        )
    };
}

export default App;